import { useMemo, useState } from "react";
import { HoveredFeature } from "../../types";
import { createInteractiveFeatureCollection } from "../mapFunctions";
import { UseInteractiveFeaturesResult } from "../../types";

export const nullFeatureProps: HoveredFeature = {
  properties: null,
  geometry: null,
  type: null,
  apiRef: null,
};

export function useInteractiveFeatures(): UseInteractiveFeaturesResult {
  const [hoveredFeature, setHoveredFeature] =
    useState<HoveredFeature>(nullFeatureProps);
  const [clickedFeature, setClickedFeature] =
    useState<HoveredFeature>(nullFeatureProps);

  const hoveredFeatureCollection = useMemo(
    () => createInteractiveFeatureCollection(hoveredFeature),
    [hoveredFeature],
  );

  const clickedFeatureCollection = useMemo(
    () => createInteractiveFeatureCollection(clickedFeature),
    [clickedFeature],
  );

  const clearHoveredFeature = () => setHoveredFeature(nullFeatureProps);

  return {
    hoveredFeature,
    clickedFeature,
    hoveredFeatureCollection,
    clickedFeatureCollection,
    setHoveredFeature,
    setClickedFeature,
    clearHoveredFeature,
  };
}
